// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__.O(undefined, ["shared-vendor","shared-resources"], () => (__webpack_require__("4d97f026f22b75ce9743")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["shared-vendor","shared-resources"], () => (__webpack_require__("2e9d6d65d6cd70d6a784")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
